import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { PARAMS_HED } from 'src/app/global/constants';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const tackleHed = ['/paymentapi/process-transaction']
    const url = request.url
    const millis = (new Date()).getTime()
    if (tackleHed.includes(url)) {

      const sutp = (PARAMS_HED[url] as string).split('.')
      let p = request.body
      for (let i = 0; i < sutp.length; i++) {
        p = p[sutp[i]]
      }
      const hedFrame = { "0": millis.toString(), "1": p }
      const hed = CryptoJS.AES.encrypt(JSON.stringify(hedFrame), environment.sample).toString();
      request = request.clone({
        headers: request.headers.set('hed', hed)
      });
    }
    return next.handle(request);
  }
}
